{
  "title": "Utilisateurs",
  "subtitle": "Liste des utilisateurs de votre réseau grand compte.",
  "search": "Rechercher un utilisateur",
  "filters": "Filtres",
  "roleFilter": "Rôle",
  "statusFilter": "Statut",
  "loadMore": "Charger plus",
  "table": {
    "network": "Réseau",
    "role": "Rôle",
    "user": "Utilisateur",
    "applicant": "Demandeur",
    "files": "Dossiers",
    "groups": "Groupes",
    "status": "Statut",
    "infoQuality": "Qualité infos",
    "description": "Description",
    "other": "autre",
    "others": "autres"
  },
  "status": {
    "pending": "En attente",
    "inactive": "Inactif",
    "active": "Actif",
    "deleted": "Supprimé"
  },
  "infoQuality": {
    "missing": "Manquante",
    "partial": "Partielle",
    "complete": "Complète"
  }
}
